<template>
  <!-- Modals -->
  <div class="mt-4">
    <head>
      <meta property="og:type" content="website" />
      <meta property="og:url" :content="url_p" />
      <meta property="og:title" content="Viva Ticket" />
      <meta
        property="og:description"
        content="Crie e viva experiências únicas quando e onde estiver"
      />
      <meta
        property="og:image"
        content="https://i.im.ge/2023/01/12/sF2iwq.Logo-2023.png"
      />
      <meta property="og:image" itemprop="image" :content="lista_evento.fly1" />
    </head>
    <a
      v-if="lista_evento.telefone_producao"
      :href="'https://wa.me/' + lista_evento.telefone_producao"
      style="
        position: fixed;
        width: 60px;
        height: 60px;
        bottom: 40px;
        right: 40px;
        background-color: #25d366;
        color: #fff;
        border-radius: 50px;
        text-align: center;
        font-size: 30px;
        box-shadow: 1px 1px 2px #888;
        z-index: 600;
      "
      target="_blank"
    >
      <i style="margin-top: 16px" class="fa fa-whatsapp"></i>
    </a>
    <section
      class="section section-sm section-shaped overflow-hidden my-0 body"
    >
      <!-- <div class="shape shape-style-1 shape-default shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div> -->
      <!-- <div class="row">
        <div class="p-5 py-0 pb-lg"> -->
      <!-- <video
        v-show="lista_evento.id == 46"
        id="player3"
        autoplay="true"
        muted="true"
        loop
        class="bg_video"
      >
        <source src="arquivos/Biriguis.mp4" type="video/webm" />
        <source src="arquivos/Biriguis.mp4" type="video/mp4" />
      </video> -->
      <img
        width="100%"
        height="100%"
        :src="lista_evento.fly1"
        class="bg_video"
      />
      
      <!-- <video
        v-show="lista_evento.id == 49"
        id="player4"
        autoplay="true"
        loop
        class="bg_video"
      >
        <source :src="'arquivos/' + lista_evento.videos_id" type="video/webm" />
        <source :src="'arquivos/' + lista_evento.videos_id" type="video/mp4" />
      </video> -->
      <div class="row justify-content-md-center">
        <div class="col-md-12 text-center col-12">
          <!-- <img :src="lista_evento.banner_id" class="im3" /> -->
          <img  v-lazy="lista_evento.banner_id" class="im3 pt-4" />

          <!-- <video autoplay  :src="host + lista_evento.videos_id"></video> -->
        </div>

        <!-- <video    
          v-if="ixibir_video " width="100%" height="100%" controls autoplay loop muted>
  <source   :src="host + lista_evento.videos_id" type="video/mp4" />
</video> -->
      </div>
      <div v-if="!lista_evento.fly2" class="row justify-content-md-center padd ">
        <div class="col-md-6 pull text-center col-12 pb-2">
          <img
          
            width="100%"
            :height="lista_evento.fly2? '100%' :check_mobile ? '500px': '700px'"
            v-lazy="lista_evento.fly1"
            class="im2"
          />
        </div>
        <!-- <propaganda v-if="ixibir_video"></propaganda> -->
        <div v-if="lista_evento.videos_id" class="col-md-6 pull text-center col-12">
          <!-- <video id="player2" width="100%" height="100%"  autoplay loop muted>
            <source src="arquivos/Biriguis3.mp4" type="video/mp4" />
          </video> -->
          <video
            width="100%"
            height="700px"


            v-lazy="'arquivos/'+lista_evento.videos_id"
            frameborder="0"
            allowfullscreen
            allow="autoplay;muted;loop;"
            autoplay
            loop
          ></video>
        </div>
      </div>
      <div v-if="lista_evento.fly2" class="row justify-content-md-center padd ">
        <div :class="lista_evento.videos_id ?'col-md-4':'col-md-6'" class="pull text-center col-12 pb-2">
          <img
            width="100%"
            :height="lista_evento.videos_id? '100%' :check_mobile ? '500px': '700px'"
            :src="lista_evento.fly1"
            class="im2"
          />
        </div>
        <!-- <propaganda v-if="ixibir_video"></propaganda> -->
        <div v-if="lista_evento.videos_id" class="col-md-4 pull text-center col-12">
          <!-- <video id="player2" width="100%" height="100%"  autoplay loop muted>
            <source src="arquivos/Biriguis3.mp4" type="video/mp4" />
          </video> -->
          <iframe
            width="100%"
            height="500"
            :src="'arquivos/'+lista_evento.videos_id"
            frameborder="0"
            allowfullscreen
            allow="autoplay;muted;loop;"
            autoplay
            loop
          ></iframe>
        </div>

        <div :class="lista_evento.videos_id ?'col-md-4':'col-md-6'" class=" pull text-center col-12">
          <img
            width="100%"
            :height="lista_evento.videos_id? '100%' :check_mobile ? '500px': '700px'"

            :src="lista_evento.fly2"
            class="im2"
          />
        </div>
      </div>
      <!-- <div class="col-md-12 col-lg-12 col-12 pt-5 text-center ">
        <h1 class="font-weight-600 two-colors card  ">
        {{ lista_evento.nome_evento }}
        </h1>
      </div> -->
      <div class="row justify-content-md-center padd pl-1 pr-1">
        <div class="col-md-9 col-lg-9 col-12">
          <div class="col-md-12 col-12">
            <div style="height: auto" class="row">
              <div class="wrap col-md-12 col-lg-12 col-12 text-center">
                <!-- <bbt
                  @click="analits(lista_evento.sc_interno)"
                  v-if="lista_evento.sc_interno"
                  v-show="!check_mobile"
                  style="border-radius: 100px"
                >
                  Comprar Ingressos
                </bbt> -->

                <bbt style="border-radius: 100px" @click="share" class="bbt">
                  compartilhar
                  <i class="fa fa-share"></i>
                </bbt>
                <bbt
                  @click="analits(lista_evento.sc_interno)"
                  v-if="lista_evento.sc_interno"
                  class="mobile bbt"
                  style="font-size: 25px"
                >
             comprar
                </bbt>
                <bbt
                  @click="analits(lista_evento.sc_externo)"
                  v-if="!lista_evento.sc_interno"
                  class="bbt mobile"
                >
                  comprar
                </bbt>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row padd justify-content-md-center">
      <ingressos :ingressos="lista_evento.ingressos" :evento="lista_evento"></ingressos>

        <!-- <div
          class="col-md-3 col-6 text-center text-uppercase"
          :style="
            check_mobile & (index >= 2)
              ? 'margin-top:90px;'
              : 'margin-top:10px;'
          "
          v-for="(item, index) in lista_evento.ingressos"
          :key="index"
        >
          <div  @click="analits(lista_evento.sc_interno ?lista_evento.sc_interno:lista_evento.sc_externo)">
            <img
              v-if="!check_mobile"
              width="100%"
              height="100%"
              src="ingressos.png"
              style="position: absolute; left: 19%; height: 250px; width: 61%"
              class="im2"
            />
            <img
            
              v-if="check_mobile"
              width="100%"
              height="100%"
              src="ingressos.png"
              style="position: absolute; left: 6%; height: 250px; width: 87%"
              class="im2"
            />
            <div style="position: relative; text-align: center"  >
              <div class="card-title-edit col-md-12">
                <span class="card-text-edit"> {{ item.obs }} </span>
              </div>
              <p style="font-size: 20px" class="font-weight-900 line-h">
                {{ item.tipo }}
              </p>
              <p style="font-size: 15px" class="font-weight-900 line-h">
                {{ item.tipo2 }}
              </p>

              <p style="color: #4169e1" class="font-weight-900 text-p25 line-h">
                R${{ item.valor.replace(".", ",") }}
              </p>
              <p
                style="line-height: 0; font-size: 10px"
                class="font-weight-900"
              >
                {{ item.desc1 }}
              </p>

              <p
                style="line-height: 0; font-size: 10px"
                class="font-weight-900"
              >
                {{ item.desc2 }}
              </p>
              <p
                style="line-height: 1; line-clamp: 1; font-size: 10px"
                class="font-weight-900"
              >
                {{ item.desc3 }}
              </p>
            </div>

            <div v-if="item.obs2" class="card-title-edit2 col-md-12">
              <span class="card-text-edit2"> {{ item.obs2 }} </span>
            </div>
          </div>
        </div> -->
      </div>

      <div class="card" style="margin-top: 200px">
        <div class="row" v-if="check_mobile">
          <div class="col-md-6 col-lg-6 col-12 pb-3 pt-mobile">
            <div class="p-1 card">
              <span class="col-md-12 col-12 text-center">
                <span
                  style="
                    font-size: 20px;
                    text-transform: capitalize;
                    color: black;
                  "
                  class="font-weight-700"
                  >{{ lista_evento.nome_evento }}</span
                >
              </span>
              <span class="col-md-12 col-12 text-center">
                <span
                  style="
                    font-size: 15px;
                    text-transform: capitalize;
                    color: black;
                  "
                  class="font-weight-700 h6"
                  >{{ lista_evento.generos }}</span
                >
              </span>
              <p class="col-md-12 col-12">
                <span class="content icon-container icon icon-fill">
                  <i class="fa fa-calendar"></i>
                </span>

                <!-- <br v-if="check_mobile"> -->

                <span
                  style="text-transform: capitalize"
                  class="font-weight-700"
                  >{{ datt }}</span
                >
                <!-- <span  class="font-weight-700 ">{{ datt }}</span> -->
              </p>
              <p class="col-md-12 col-12">
                <span class="content icon-container icon icon-fill">
                  <i class="fa fa-clock-o"></i>
                </span>

                <span
                  style="text-transform: capitalize"
                  class="font-weight-700"
                  >{{ horat }}</span
                >
                <!-- <span  class="font-weight-700 ">{{ datt }}</span> -->
              </p>

              <p class="col-md-12 pt-2">
                <span class="content icon-container icon icon-fill">
                  <i class="fa fa-university"></i>
                </span>
                <span class="font-weight-700">Produção: </span>
                <span class="font-weight-300">{{
                  lista_evento.produtora_produtor
                }}</span>
                <br />
                <span
                  style="margin-left: 44px; margin-top: 30px"
                  class="font-weight-700"
                  >{{
                    this.lista_evento.cpf_cnpj.length == 11 ? "CPF" : "CNPJ"
                  }}: </span
                >{{ cnpjglobal }}
              </p>
              <p class="col-md-12 pt-2">
                <span class="content icon-container icon icon-fill">
                  <i class="fa fa-child"></i>
                </span>
                <span class="font-weight-700">Classificação: </span>
                <span class="font-weight-300">{{
                  lista_evento.classificacao
                }}</span>
              </p>
              <p class="col-md-12 pt-2">
                <span class="content icon-container icon icon-fill">
                  <i class="fa fa-map-marker"></i>
                </span>

                <span class="font-weight-700 text-uppercase">Local: </span
                >{{ this.lista_evento.nome_local_evento }}
                <br />
                <span
                  style="margin-left: 44px; margin-top: 30px"
                  class="font-weight-700"
                  >Endereço: </span
                >{{ this.lista_evento.endereco }}
                <br />

                <span
                  style="margin-left: 44px; margin-top: 30px"
                  class="font-weight-700"
                  >Cidade: </span
                >{{ this.lista_evento.cidade + " - " + this.lista_evento.uf }}
              </p>

              <div v-html="lista_evento.localizacao"></div>
            </div>
          </div>
          <div class="col-md-6 col-lg-6 col-12 pt-mobile">
            <b-tabs
              class="p-1 col-12 col-md-12 col-lg-12"
              active-nav-item-class="font-weight-bold text-uppercase "
              active-tab-class="font-weight-bold text-pills"
            >
              <b-tab title="PONTOS DE VENDAS">
                <b-card-text>
                  <div class="card flex-row flex-wrap p-1 text-capitalize" v-for="(pd,i) in lista_evento.pdv" :key="i">
                    <img
                    :src="pd.logo ? pd.logo :'logo.png'"
                      style="border-radius: 60px"
                      width="50px"
                      height="50px"
                      alt=""
                    />
                    <div class="card-block px-2" style="font-size: 13px">
                      {{ pd.nome }} -
                      {{ pd.cidade }}
                      <br />

                      {{
                        hora_pdv(
                          pd.hora_abe,
                          pd.hora_fec
                        )
                      }} - <span class="text-uppercase" style="font-size: 12px;">{{ JSON.parse(pd.ds)[0] + ' à ' + JSON.parse(pd.ds)[JSON.parse(pd.ds).length-1] }}</span> 



<!-- <b-button>
  adsa
  <i class="fas fa-directions"></i>


</b-button> -->

                    </div>
                    
                    <div class="w-100"></div>
                    </div>
                  
               
                      <!-- <b-form-group>
                      <b-form-checkbox-group
                     size="col"
                        class="ml-5"
                        disabled
                        :options="dias_semana"
                        v-model="ds"
                        button-variant="primary"
                        buttons
                        
                      >
                      </b-form-checkbox-group>
                    </b-form-group> -->
                  
                  <!-- <b-card
                    :img-src="lista_evento.pdv.logo"
                    width="39px"
                    style="border-radius: 0px"
                    img-alt="Card image"
                    img-left
                    class="mb-3"
                  >
                    <b-card-text>
                      {{ lista_evento.pdv.nome }}
                      <br />
                      {{ lista_evento.pdv.cidade }}
                      <br />

                      {{ lista_evento.pdv.hora_abe }} ás
                      {{ lista_evento.pdv.hora_fec }}
                    </b-card-text>
                  </b-card> -->
                </b-card-text>
              </b-tab>
              <!-- <b-tab title="INFORMAÇÕES">
                <b-card-text class="text-center">
                  <div :class="ocultador" class="text-left">
                    <span style="height: auto" class="p-3">
                      <span class="" v-html="lista_evento.informacoes"> </span>
                    </span>
                  </div>
                  <span
                    type="button"
                    style="color: black"
                    class="font-weight-600"
                    @click="desocultar()"
                    >{{ ler }}</span
                  >
                </b-card-text></b-tab -->
              >
              <!-- <b-tab title="INGRESSOS"
                ><b-card-text>
                  <span style="height: auto" class="p-3">
                    <i v-html="lista_evento.ingressos"></i>
                  </span> </b-card-text
              ></b-tab> -->
            </b-tabs>
          </div>
        </div>
        <div class="row" v-if="!check_mobile">
          <div class="col-md-6 col-lg-6 col-12 pt-mobile">
            <b-tabs
              class="p-1 col-12 col-md-12 col-lg-12"
              active-nav-item-class="font-weight-bold text-uppercase "
              active-tab-class="font-weight-bold text-pills"
            >
              <!-- <b-tab title="INGRESSOS"
                ><b-card-text>
                  <span style="height: auto" class="p-3">
                    <i v-html="lista_evento.ingressos"></i>
                  </span> </b-card-text
              ></b-tab> -->

              <b-tab title="PONTOS DE VENDAS">
                <b-card-text>
                  <div class="card flex-row flex-wrap p-1 text-capitalize" v-for="(pd,i) in lista_evento.pdv" :key="i">
                    <img
                      :src="pd.logo ? pd.logo :'logo.png'"
                      style="border-radius: 60px"
                      width="80px"
                      height="80px"
                      alt=""
                    />
                    <!-- <div class="card-block px-2" style="font-size: 16px">
                      {{ pd.nome }} -
                      {{ pd.cidade }}
                      <br />

                      {{
                        hora_pdv(
                          pd.hora_abe,
                          pd.hora_fec
                        )
                      }} - <span class="text-uppercase" style="font-size: 15px;">{{ JSON.parse(pd.ds)[0] + ' à ' + JSON.parse(pd.ds)[JSON.parse(pd.ds).length-1] }}</span> 




                    </div> -->
                    <!-- <div class="w-100"></div> -->
                    </div>
                  
               
                      <!-- <b-form-group>
                      <b-form-checkbox-group
                     size="col"
                        class="ml-5"
                        disabled
                        :options="dias_semana"
                        v-model="ds"
                        button-variant="primary"
                        buttons
                        
                      >
                      </b-form-checkbox-group>
                    </b-form-group> -->
                  
                  <!-- <b-card
                    :img-src="lista_evento.pdv.logo"
                    width="39px"
                    style="border-radius: 0px"
                    img-alt="Card image"
                    img-left
                    class="mb-3"
                  >
                    <b-card-text>
                      {{ lista_evento.pdv.nome }}
                      <br />
                      {{ lista_evento.pdv.cidade }}
                      <br />

                      {{ lista_evento.pdv.hora_abe }} ás
                      {{ lista_evento.pdv.hora_fec }}
                    </b-card-text>
                  </b-card> -->
                </b-card-text>
              </b-tab>
              <!-- <b-tab title="INFORMAÇÕES">
                <b-card-text class="text-center">
                  <div :class="ocultador" class="text-left">
                    <span style="height: auto" class="p-3">
                      <span class="" v-html="lista_evento.informacoes"> </span>
                    </span>
                  </div>
                  <span
                    type="button"
                    style="color: black"
                    class="font-weight-600"
                    @click="desocultar()"
                    >{{ ler }}</span
                  >
                </b-card-text>
              </b-tab> -->
            </b-tabs>
          </div>
          <div class="col-md-6 col-lg-6 col-12 pb-3 pt-mobile">
            <div class="p-1 card">
              <span class="col-md-12 col-12 text-center">
                <span
                  style="text-transform: capitalize; color: black"
                  class="font-weight-700 h2"
                  >{{ lista_evento.nome_evento }}</span
                >
              </span>
              <span class="col-md-12 col-12 text-center">
                <span       style="text-transform: capitalize; color: black"
                  class="font-weight-700 h6"> generos</span>
                <p
                  style="text-transform: capitalize; color: black"
                  class="font-weight-700 h6"
                  >
            
                  
                  {{ lista_evento.generos }}</p
                >
              </span>
              <p class="col-md-12 col-12">
                <span class="content icon-container icon icon-fill">
                  <i class="fa fa-clock-o"></i>
                </span>

                <!-- <br v-if="check_mobile"> -->

                <span
                  style="text-transform: capitalize"
                  class="font-weight-700"
                  >{{ datt }}</span
                >

                <!-- <span  class="font-weight-700 ">{{ datt }}</span> -->
              </p>
              <p class="col-md-12 pt-2">
                <span class="content icon-container icon icon-fill">
                  <i class="fa fa-university"></i>
                </span>
                <span class="font-weight-700">Produção: </span>
                <span class="font-weight-300">{{
                  lista_evento.produtora_produtor
                }}</span>
                <br />
                <span
                  style="margin-left: 44px; margin-top: 30px"
                  class="font-weight-700"
                  >{{
                    this.lista_evento.cpf_cnpj.length == 11 ? "CPF" : "CNPJ"
                  }}: </span
                >{{ cnpjglobal }}
              </p>

              <p class="col-md-12 pt-2">
                <span class="content icon-container icon icon-fill">
                  <i class="fa fa-child"></i>
                </span>
                <span class="font-weight-700">Classificação: </span>
                <span class="font-weight-300">{{
                  lista_evento.classificacao
                }}</span>
              </p>
              <p class="col-md-12 pt-2">
                <span class="content icon-container icon icon-fill">
                  <i class="fa fa-map-marker"></i>
                </span>

                <span class="font-weight-700">Local: </span
                >{{ this.lista_evento.nome_local_evento }}
                <br />
                <span
                  style="margin-left: 44px; margin-top: 30px"
                  class="font-weight-700"
                  >Endereço: </span
                >{{ this.lista_evento.endereco }}
                <br />

                <span
                  style="margin-left: 44px; margin-top: 30px"
                  class="font-weight-700"
                  >Cidade: </span
                >{{ this.lista_evento.cidade + " - " + this.lista_evento.uf }}
              </p>

              <div v-html="lista_evento.localizacao"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- </div>
      </div> -->
    </section>

    <!-- <modal :show.sync="modals.modal1"  modal-classes="modal-dialog-centered modal-lg col-12"
   
        >
      <embed
        type="text/html"
        v-if="lista_evento.sc_interno"
        :src="lista_evento.sc_interno"
        width="500"
        height="500"
      />
      <embed
        type="text/html"
        v-if="!lista_evento.sc_interno"
        :src="lista_evento.sc_externo"
            width="875"
        height="600"
      />
      <template slot="footer">
        <base-bbt type="link" class="ml-auto" @click="modals.modal1 = false"
          >Close
        </base-bbt>
      </template>
    </modal> -->
  </div>
</template>
<script>
import myVideo from "vue-video";
import Modal from "@/components/Modal.vue";
import video from "./propaganda.vue";
import propaganda from "./propaganda.vue";
import moment from "moment";
import ingressos from "@/views/components/eventos/ingressos.vue"

export default {
  components: {
    Modal,
    myVideo,
    propaganda,
    ingressos
  },
  data() {
    return {
      url_p: window.location.href,
      modals: {
        modal1: false,
        modal2: false,
        modal3: false,
        slide: 0,
        sliding: null,
      },
      ixibir_video: false,
      back_video: false,
      host: process.env.VUE_APP_API_URL + "arquivo/banners/",

      ocultador: "expand",
      ler: "Ler mais",
      dias_semana: [
        { text: "seg", value: "seg" },
        { text: "ter", value: "ter" },
        { text: "qua", value: "qua" },
        { text: "qui", value: "qui" },
        { text: "sex", value: "sex" },
        { text: "sab", value: "sab" },
        { text: "dom", value: "dom" },
      ],
      ds: [],
    };
  },
watch:{
msn_compra(){
  this.ts = this.msn_compra
}
},
  computed: {
    msn_compra() {
      return this.$store.state.evento.msn_compra;
    },
    cnpjglobal() {
      let cpf = this.lista_evento.cpf_cnpj;

      if (this.lista_evento.cpf_cnpj.length == 11) {
        return (
          cpf.slice(0, 3) +
          "." +
          cpf.slice(3, 6) +
          "." +
          cpf.slice(6, 9) +
          "-" +
          cpf.slice(9, 11)
        );
      }
      let x = this.lista_evento.cpf_cnpj
        .replace(/\D/g, "")
        .match(/(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/);
      return !x[2]
        ? x[1]
        : x[1] +
            "." +
            x[2] +
            "." +
            x[3] +
            "/" +
            x[4] +
            (x[5] ? "-" + x[5] : "");
    },
    check_mobile() {
      var check = false; //wrapper no check
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },
    lista_evento() {
      return this.$store.state.evento.evento;
    },
    datt() {
      moment.locale("pt-br");
      let data = moment(this.lista_evento.data_evento, "DD-MM-YYYY").format(
        "dddd, LL"
      );
      return data;
    },
    horat() {
      let hora = moment(this.lista_evento.horario_evento, "HH:mm:ss").format(
        "HH:mm"
      );
      return hora;
    },
  },
  created() {
    this.init();
    this.init2();

    this.$ga.page({
      page: "/",
      title: this.$route.params.nome,
      location: window.location.href,
    });
  },

  methods: {
    share() {
      if (navigator.share !== undefined) {
        navigator
          .share({
            title: this.lista_evento.nome_evento,
            text: "Acesso nosso Evento",
            url: window.location.href,
          })
          .then(() => console.log("Successful share"))
          .catch((error) => console.log("Error sharing", error));
      }
    },
    desocultar() {
      if (this.ocultador == "expander") {
        this.ocultador = "expand";
        this.ler = "Ler mais";
      } else {
        this.ler = "Ler menos";

        this.ocultador = "expander";
      }
    },
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
   async analits(link) {


      window.open(link, "_blank");
      // this.modals.modal1 = true;
      // this.$store.dispatch("evento/analitsEvento", {
      //   eventos_id: this.$route.params.id,
      // });

      // this.ts = 'comprar' 
    },
    async init() {
      await this.$store.dispatch("evento/listar_evento", {
        nome: this.$route.params.nome,
        id: this.$route.params.id,
      });
      if (this.lista_evento.status != 1) {
        window.location.href = "https://vivaticket.autsteeltech.com/";
      }
    

      await this.sleep(900);

      console.log(this.ixibir_video);

      if (this.lista_evento.videos_id) {
        this.ixibir_video = true;
      }
    },
    async init2() {
      await this.sleep(300);

      document.getElementById("player3").muted = true;
      document.getElementById("player4").muted = true;

      // document.getElementById("player2").muted = false;

      // back_video = true
    },
    sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    hora_pdv(abe, fec) {
      return (
        moment(abe, "HH:mm:ss").format("HH:mm") +
        " às " +
        moment(fec, "HH:mm:ss").format("HH:mm")
      );
    },
  },
};
</script>

<style lang="scss"  scoped>
.mobile {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 100%;
  z-index: 5;
}
.position-btn {
  position: relative;
  width: 100%;
}
.expand {
  width: 100%;
  height: 200px;
  background: rgb(255, 255, 255);
  overflow: hidden;
  padding-bottom: 18px;
}

.expander {
  width: 100%;
  height: 100%;
  background: rgb(255, 255, 255);
  overflow: hidden;
  padding-bottom: 18px;
}
.card-text-edit {
  background: #6b8e23;
  color: white;
  font-weight: 700;
  letter-spacing: 1px;
  font-size: 12px;
  padding: 3px;
  border-radius: 10px;
}
.card-text-edit2 {
  background: #4169e1;
  color: white;
  font-weight: 700;
  letter-spacing: 1px;
  font-size: 12px;
  padding: 3px;
  border-radius: 10px;
}
.card-title-edit {
  top: -10px;
  right: 10%;
  left: 0;
}
.card-title-edit2 {
  position: absolute;
  bottom: -20px;
  right: 50%;
  left: 0;
}
.padd {
  padding: 10px;
}
.im2 {
  border-radius: 15px;
  max-width: 80%;
}
.im3 {
  width: 100%;
}
strong {
  font-weight: 600;
}
.card {
  margin-top: 10px;
  border: 2px solid #fff;
  border-radius: 20px;
  color: #0a0a0a;

  /* -webkit-transition: -webkit-transform 0.5s ease;
  transition: transform 0.5s ease; */
}

.line-h {
  line-height: 0.4;
}
.text-p25 {
  font-size: 30px;
}
.pt-mobile {
  margin-top: 15px;
}
@media screen and (max-width: 890px) {
  .im2 {
    border-radius: 15px;
    max-width: 100%;
  }
  .pt-mobile {
    margin-top: 15px;
  }
  .text-p25 {
    font-size: 25px;
    line-height: 1;
  }
}

@media screen and (max-width: 375px) {
  .im2 {
    border-radius: 15px;
    max-width: 100%;
  }
  .pt-mobile {
    margin-top: 20px;
  }
}

bbt {
  min-width: 80px;
  min-height: 30px;
  font-family: "Nunito", sans-serif;
  font-size: 15px;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  font-weight: 700;
  color: #ffffff;
  background: #4169e1;
  background: linear-gradient(90deg, #4169e1) 0%, #3f66dc 100%;
  border: none;
  // border-radius: 1000px;
  box-shadow: 12px 12px 24px rgba(46, 50, 44, 0.64);
  transition: all 0.3s ease-in-out 0s;
  cursor: pointer;
  outline: none;
  position: relative;
  padding: 10px;
}



.bbt:hover,
.bbt:focus {
  color: #166509;
  transform: translateY(-6px);
  background: #f8f8f3;
}

bbt:hover::before,
bbt:focus::before {
  opacity: 0.7;
}

// bbt::after {
//   content: "";
//   width: 10px;
//   height: 10px;
//   border-radius: 100%;
//   border: 6px solid #1349ea;
//   position: absolute;
 
//   transform: translate(-50%, -50%);
//   animation: ring 1.5s infinite;
// }

// bbt:hover::after,
// bbt:focus::after {
//   animation: none;
//   display: none;
// }

@keyframes ring {
  0% {
    width: 30px;
    height: 30px;
    opacity: 0.8;
  }
  100% {
    width: 260px;
    height: 135px;
    opacity: 0.3;
  }
}

/* 
.card:hover {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
} */

$icon-size: 30px;
$border-radius: 0.5; //15% = 0.15, 50% = 0.50 etc.

$background: #07bf11;
$background-b: #1e17ad;

// Icon Colors
$green: #14690b;
$red: #c82647;
$green-l: #8cc63f;
$orange: #eb9532;
$purple: #7e3661;

// Text
$white: #0a2b05;

.icon-container {
  width: 100%;
  height: $icon-size;
}
.container {
  display: table;
  height: 95vh;
  width: 90%;
  padding-bottom: 5vh;
  margin: auto auto;
  @media (max-width: 900px) {
  }
  background: $background;
  z-index: -1;
}

.content {
  display: table-cell;
  text-align: center;
  vertical-align: middle;
}
.icon {
  cursor: pointer;
  position: relative;
  display: inline-block;
  width: $icon-size;
  height: $icon-size;
  margin-left: $icon-size/4;
  margin-right: $icon-size/4;
  border-radius: $icon-size * $border-radius;
  color: $white;

  overflow: hidden;
  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    transition: all 0.25s ease;
    border-radius: $icon-size * $border-radius;
  }
  i {
    position: relative;
    font-size: $icon-size/1.5;
    margin-top: $icon-size/6;
    transition: all 0.25s ease;
  }
}

i:hover {
  color: #e6e6e6;
}

.icon-fill {
  &::before {
    transition-duration: 0.5s;
    box-shadow: inset 0 0 0 1px $green;
  }
  &:hover::before {
    box-shadow: inset 0 0 0 $icon-size $green;
  }
  &:hover {
    color: #e6e6e6;
  }
}

.icon-enter {
  &::after {
    box-shadow: inset 0 0 0 1px $orange;
  }
  &::before {
    border-radius: 0;
    margin-left: -100%;
    box-shadow: inset 0 0 0 $icon-size $orange;
  }
  &:hover::before {
    margin-left: 0;
  }
}

.icon-expand {
  &::after {
    box-shadow: inset 0 0 0 1px $red;
  }
  &::before {
    background: $red;
    box-shadow: inset 0 0 0 $icon-size $background;
  }
  &:hover::before {
    box-shadow: inset 0 0 0 1px $background;
    color: #1e17ad;
  }
}

.icon-collapse {
  &::before {
    border-radius: 0;
  }
  &:hover::before {
    box-shadow: inset 0 $icon-size/2 0 0 $green-l,
      inset 0 $icon-size/-2 0 0 $green-l;
  }
  &::after {
    box-shadow: inset 0 0 0 1px $green-l;
  }
}

.icon-rotate {
  box-shadow: inset 0 0 0 1px $purple;
  &::after,
  &::before {
    border: 0px solid transparent;
  }
  &:hover::before {
    transition: border-top-width 0.3s ease, border-top-color 0.3s ease;
    border-width: $icon-size;
    border-top-color: $purple;
  }
  &:hover::after {
    transition: border-left-width 0.3s ease, border-left-color 0.3s ease;
    border-width: $icon-size;
    border-left-color: $purple;
  }
  &:hover {
    transition: background 0.001s ease 0.3s;
    background: $purple;
  }
  i {
    z-index: 1;
  }
}

// span {
//   font-size: 14px;
// }
@media (max-width: 1200px) {
  span {
    font-size: 1.2em;
  }
  b-tab {
    font-size: 1.2em;
  }
}
@media (max-width: 768px) {
  span {
    font-size: 1.1;
  }
  b-tab {
    font-size: 1.1;
  }
}
@media (max-width: 468px) {
  span {
    font-size: 0.8em;
  }
  b-tab {
    font-size: 0.8em;
  }
}
@media (max-width: 370px) {
  span {
    font-size: 0.76em;
  }
  b-tab {
    font-size: 0.76em;
  }
}
@media (max-width: 340px) {
  span {
    font-size: 0.67em;
  }
  b-tab {
    font-size: 0.67em;
  }
}

.two-colors {
  font-size: 38px;
  background: linear-gradient(
    to left,
    rgb(199, 15, 76) 20%,
    rgb(235, 238, 235) 20%,
    rgb(185, 157, 14) 40%,
    rgb(210, 216, 210) 40%,
    rgb(199, 15, 76) 70%,
    rgb(210, 216, 210) 40%,
    rgb(199, 15, 76) 20%,
    rgb(202, 226, 25) 60%,
    rgb(199, 15, 76) 50%,
    rgb(216, 203, 22) 80% rgb(215, 150, 29) 80%,
    rgb(201, 15, 86) 60%,
    rgb(216, 203, 22) 80%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  font-weight: 900;
  font-family: Arial;
}
.bg_video {
  position: absolute;
  right: 0;
  bottom: 0;
  background-position: 10% 0;
  //  height: 200px;
  top: 0;
  // z-index: -10px;
  min-width: 100%;
  min-height: 100%;
  -webkit-filter: blur(5px); /* Safari 6.0 - 9.0 */
  filter: blur(5px);

  // background: url(images/torre.jpg) no-repeat;
}
</style>
